import React, { useContext } from 'react'
import { RiskProductsContext } from '../../context'
import { Grid } from '@components/layout/Grid'
import { Card, CardHeading, CardContent, CardFooter } from '@components/layout/Card'
import { PlusCircle } from '@components/Icons/PlusCircle'
import { Button } from '@components/Button'
import { humanizeString } from '@utils/stringMinipulation'

export const Create = () => {
  const {
    state: { supportedRiskProductTypes },
    actions: { setRiskProductTypeToCreate, goToIndex }
  } = useContext(RiskProductsContext)

  return (
    <>
      <Grid className='grid--small-columns'>
        {supportedRiskProductTypes.map((riskProductType) =>
          <Card key={riskProductType} darkBorder className='ui-card--entity-types' onClick={setRiskProductTypeToCreate(riskProductType)}>
            <CardHeading>
              <h5>{humanizeString(riskProductType)}</h5>
            </CardHeading>
            <CardContent>
              <PlusCircle />
            </CardContent>
          </Card>
        )}
      </Grid>
      <CardFooter>
        <Button tertiary onClick={goToIndex}>Back</Button>
      </CardFooter>
    </>
  )
}
